export default [
    {
        "description": "This value indicates the payroll frequency is weekly.",
        "code": "WKLY",
        "valueIdentifier": 460,
        "typeIdentifier": 64,
        "shortname": "Weekly",
        "fullname": "Weekly",
        "sequenceNumber": 0
    },
    {
        "description": "This value indicates the payroll frequency is biweekly.",
        "code": "BIWK",
        "valueIdentifier": 461,
        "typeIdentifier": 64,
        "shortname": "Biweekly",
        "fullname": "Biweekly",
        "sequenceNumber": 0
    },
    {
        "description": "This value indicates the payroll frequency is twice a month.",
        "code": "TWMO",
        "valueIdentifier": 462,
        "typeIdentifier": 64,
        "shortname": "TwiceAMonth",
        "fullname": "Twice A Month",
        "sequenceNumber": 0
    },
    {
        "description": "This value indicates the payroll frequency is monthly.",
        "code": "MTLY",
        "valueIdentifier": 463,
        "typeIdentifier": 64,
        "shortname": "Monthly",
        "fullname": "Monthly",
        "sequenceNumber": 0
    }
]
